require('./bootstrap');
const bootstrap = require('bootstrap-sass');
require('bootstrap4-toggle')
//require('overlayscrollbars')
require('admin-lte');
window.JSZip = require('jszip');
window.moment = require('moment')
window.pdfMake  = require('pdfmake/build/pdfmake');
const pdfFonts = require('pdfmake/build/vfs_fonts');
pdfMake.vfs = pdfFonts.pdfMake.vfs;
require('datatables.net-dt')
require('datatables.net-bs4');
require('datatables.net-buttons-bs4');
require('datatables.net-buttons/js/buttons.colVis');
require('datatables.net-buttons/js/buttons.html5');
require('datatables.net-buttons/js/buttons.print');
//require('datatables.net-datetime');
require('datatables.net-responsive-bs4');
require('datatables.net-searchpanes-bs4');
require('datatables.net-select-bs4');
//require('datatables.net-plugins/filtering/row-based/range_dates');
require('admin-lte/dist/js/adminlte.min');
require('select2');
require('bootstrap-switch');


